import   React            ,
       { useState         ,
         useEffect        }  from 'react';

import   classNames          from 'classnames';
import   styles              from './MediaCategoryRow.module.scss';

import { MediaCategory    }  from '../../../dataTypes/mediaManagment/types';
import   Toggle              from '../../widget/inputs/Toggle';
import   Icon                from '../../widget/images/Icon';


interface MediaCategoryRowProps {
  category                 : MediaCategory;
  categorySetLenght        : number;
  onNameAndMediaTypeChange : (index: number, newName: string, newMediaType: string) => void;
  onArrowClick             : (index: number, direction: 'up' | 'down') => void;
  onDeleteClick            : (category: MediaCategory) => void;
  onVisibilityChange       : (index: number, newState: boolean) => void;
}



export const MediaCategoryRow = ({ category,
                                   categorySetLenght,
                                   onNameAndMediaTypeChange,
                                   onArrowClick,
                                   onDeleteClick,
                                   onVisibilityChange }: MediaCategoryRowProps) => {

  const [ oldCategoryName  , setOldCategoryName  ] = useState(category.name);
  const [ newCategoryName  , setNewCategoryName  ] = useState(category.name);
  const [ oldMediaType     , setOldMediaType     ] = useState(category.mediaType);
  const [ newMediaType     , setNewMediaType     ] = useState(category.mediaType);
  const [ modificationFlag , setModificationFlag ] = useState(false);

  useEffect(() => {
    setOldCategoryName(category.name);
    setNewCategoryName(category.name);
    setOldMediaType(category.mediaType);
    setNewMediaType(category.mediaType);
    setModificationFlag(false);
  }, [category.name, category.mediaType]);

  const handleNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const v = e.target.value;
    setNewCategoryName(v);
    setModificationFlag(v !== oldCategoryName || newMediaType !== oldMediaType);
  };

  const handleMediaTypeChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const v = e.target.value;
    setNewMediaType(v);
    setModificationFlag(newCategoryName !== oldCategoryName || v !== oldMediaType);
  };

  const handleChangesConfirm = () => {
    if (newCategoryName !== oldCategoryName || newMediaType !== oldMediaType) {
      onNameAndMediaTypeChange(category.rank - 1, newCategoryName, newMediaType);
      setOldCategoryName(newCategoryName);
      setOldMediaType(newMediaType);
      setModificationFlag(false);
    }
  };

  return (
    <div className={classNames(styles.row)}>

      <div className={classNames(styles.column, styles.rank)}>
        <span>{category.rank}</span>
      </div>

      <div className={classNames(styles.column, styles.name)}>
        <input type="text" value={newCategoryName} onChange={handleNameChange} />
      </div>

      <div className={classNames(styles.column, styles.mediaType)}>
        <select value={newMediaType} onChange={handleMediaTypeChange}>
          <option value="Video">Vidéo</option>
          <option value="Diapositive">Diapositive</option>
        </select>
      </div>

      <div className={classNames(styles.column, styles.nameSaving)}>
        {modificationFlag && (
           <Icon name       = "floppyDisk"
                 onClick    = {handleChangesConfirm}
		         color      = "var(--color-Icon-FG)"
                 hoverColor = "var(--color-Icon-hover-FG)" />
        )}
      </div>

      <div className={classNames(styles.column, styles.actions)}>
        {category.rank > 1 && (
          <Icon name       = "topArrow2"
                onClick    = {() => onArrowClick(category.rank - 1, 'up')}
                color      = "#215DAE"
                hoverColor = "#215DAE" />
        )}
        {category.rank < categorySetLenght && (
          <Icon name       = "bottomArrow2"
                onClick    = {() => onArrowClick(category.rank - 1, 'down')}
                color      = "#215DAE"
                hoverColor = "#215DAE" />
        )}
      </div>

      <div className={classNames(styles.column, styles.delete)}>
        <Icon name       = "trashCan"
              onClick    = {() => onDeleteClick(category)}
              color      = "#DE6B70"
              hoverColor = "#DE6B70" />
      </div>

      <div className={classNames(styles.column, styles.visibility)}>
        <Toggle
          checked  = {category.visible}
          form     = "switch"
          onChange = {() => onVisibilityChange(category.rank - 1, !category.visible)}
        />
      </div>

    </div>
  );
};

export default MediaCategoryRow;